import $ from 'jquery';
import zipTools from 'components/zip-tools';
import Navigation from 'components/nav/navigation';
import carousel from 'features/header/header-carousel-offers';
import inpageHeadline from 'components/inpage-headline';
import tdaConfig from 'lib/util/tda.config';
import tdaContext from 'lib/util/tda.context';
import wwwFuncs from 'lib/tda/www';
import anPageLoadOverall from 'lib/analytics/pageloadOverall';
import globalBlock from 'lib/analytics/blocks/global.block';
import storageUtil from 'utils/storage-util';
import 'modernizr';
import 'detectizr';
import 'components/nav/navigation-bundle.std';
import 'bootstrapModal';

var __baseTitle = /.*BuyaToyota\.com$/i;
var __titleRegex = /^(.*)\| ?([^|]*?)\.?(Buy[aA]Toyota\.com)$/i;

// BAT-3141 SEO Page Titles
function __updateTitle() {
  var txtTitle = $.trim(document.title);
  var regionUrl = 'BuyaToyota.com';
  var regionText = tdaContext.getReadableContext(tdaConfig.tda.code);

  if (tdaConfig.tda.code !== 'WWW') {
    regionUrl = regionUrl + '/' + regionText;
  }

  if (!__baseTitle.test(txtTitle)) {
    // We don't have the standard buyatoyota.com suffix
    txtTitle += ' | ' + regionUrl;
  } else {
    var matches = txtTitle.match(__titleRegex);
    // This should always result in a match if the previous test passed, but better safe than sorry.
    if (matches) {
      txtTitle = matches[1] + '| ' + regionUrl;
    }
  }
  document.title = txtTitle;
}

// TODO: Deal with these windows
window.dataLayerBAT = {};
window.dataLayerBAT.data = {};
window.dataLayerBAT.utils = {};
window.dataLayerBAT.utils.getGlobalBlock = globalBlock; // put on window for use by bat-next
anPageLoadOverall(); // don't wait for DOM ready, just go

$(document).ready(function headerBundleDomReady() {
  zipTools.init();
  storageUtil.init();
  __updateTitle();
  if (tdaConfig.tda.code === 'WWW') {
    wwwFuncs.nationalLinks.init();
    wwwFuncs.nationalForms.init();
  }

  // todo: this does NOT belong here
  if ($('div[data-component-name="404"]').length) {
    wwwFuncs.nationalLinks.init(true);
  }
});

export default {
  Navigation: Navigation,
  carousel: carousel,
  inpageHeadline: inpageHeadline,
};
